<template>
  <GenericTaskCreationStep
    class="select-import-session-dialog"
    v-on="$listeners"
    :disableNextButton="!importSession"
  >
    <template v-slot:title>Select an Import Session</template>
    <template>
      <v-card-text>
        The Matcher Task expects an import session in the
        <b>CONVERSION</b>
        phase indicating the source data has been exported and the data is ready
        to be matched.
      </v-card-text>
      <v-data-table
        class="p-10"
        item-key="id"
        :loading="isLoading"
        :headers="importSessionHeaders"
        :items="importSessions"
        :value="importSession ? [importSession] : []"
        :single-select="true"
        show-select
        v-on:input="(items) => $emit('updateImportSession', items[0])"
      />
    </template>
  </GenericTaskCreationStep>
</template>

<style>
.select-import-session-dialog {
  width: 800px;
}
</style>

<script>
import GenericTaskCreationStep from './GenericTaskCreationStep.vue';

import CONFIG from '@/config';
import { businessApiV2 } from '@/api/v2';

export default {
  components: { GenericTaskCreationStep },
  props: {
    businessId: String,
    importSession: Object
  },
  data() {
    return {
      isLoading: false,
      importSessions: [],
      importSessionHeaders: [
        { text: 'id', value: 'id' },
        { text: 'type', value: 'type' },
        { text: 'stage', value: 'stage' },
        { text: 'creationDate', value: 'creationDate' }
      ]
    };
  },
  async created() {
    this.isLoading = true;
    this.importSessions = await businessApiV2.fetchBusinessSessions(
      this.businessId,
      CONFIG.ENV
    );
    this.isLoading = false;
  }
};
</script>
